import { z } from 'zod/v4';
import { TemplateSchema } from './attachment-template.js';

export const AggregateTemplateItemSchema = TemplateSchema.extend({
  owner: z.object({ id: z.string(), companyName: z.string() }).nullable(),
});

export type AggregateTemplateItemType = z.infer<
  typeof AggregateTemplateItemSchema
>;
